import { UsTaxReturnFollowUpSectionProps } from '../TaxInfoDrawer.interface';
import { UsTaxReturnIndiciaSection } from './UsTaxReturnIndiciaSection';
import { UsTaxReturnYesSection } from './UsTaxReturnYesSection';

export function UsTaxReturnFollowUpSection({
  usTaxReturnRequired,
  hasUsIndicia,
  ...sectionProps
}: Readonly<UsTaxReturnFollowUpSectionProps>) {
  if (usTaxReturnRequired === true) {
    return <UsTaxReturnYesSection {...sectionProps} />;
  }

  if (usTaxReturnRequired === false && hasUsIndicia) {
    return <UsTaxReturnIndiciaSection {...sectionProps} />;
  }

  return null;
}
